export const CONSENT_VERSION = "1.0";
export const CONSENT_EXPIRY_DAYS = 365;
export const COOKIE_NAME = "cookie_consent";

export interface CookieConsent {
  // カテゴリ別同意状態
  essential: boolean; // 常にtrue（必須）
  functional: boolean; // 機能的Cookie
  analytics: boolean; // 分析Cookie
  advertising: boolean; // 広告Cookie

  // メタデータ
  timestamp: number; // 同意取得日時（UNIXタイムスタンプ）
  version: string; // 同意ポリシーバージョン（例: "1.0"）
  expiresAt: number; // 有効期限（12ヶ月後）
}

export type CookieCategory = "essential" | "functional" | "analytics" | "advertising";

export interface CategoryInfo {
  id: CookieCategory;
  nameKey: string; // 翻訳キー
  descriptionKey: string; // 翻訳キー
  examples: string[];
  required: boolean; // 拒否不可フラグ
  defaultEnabled: boolean; // デフォルト有効状態
}

export const COOKIE_CATEGORIES: CategoryInfo[] = [
  {
    id: "essential",
    nameKey: "cookieConsent.categories.essential.name",
    descriptionKey: "cookieConsent.categories.essential.description",
    examples: ["auth-token", "cookie_consent"],
    required: true,
    defaultEnabled: true,
  },
  {
    id: "functional",
    nameKey: "cookieConsent.categories.functional.name",
    descriptionKey: "cookieConsent.categories.functional.description",
    examples: ["language_pref", "theme_mode"],
    required: false,
    defaultEnabled: true,
  },
  {
    id: "analytics",
    nameKey: "cookieConsent.categories.analytics.name",
    descriptionKey: "cookieConsent.categories.analytics.description",
    examples: ["Google Analytics (_ga, _gid)"],
    required: false,
    defaultEnabled: false,
  },
  {
    id: "advertising",
    nameKey: "cookieConsent.categories.advertising.name",
    descriptionKey: "cookieConsent.categories.advertising.description",
    examples: ["外部広告プラットフォームのトラッカー"],
    required: false,
    defaultEnabled: false,
  },
];

// デフォルト同意設定（必須+機能的ON、分析・広告OFF）
export const DEFAULT_CONSENT: CookieConsent = {
  essential: true,
  functional: true,
  analytics: false,
  advertising: false,
  timestamp: Date.now(),
  version: CONSENT_VERSION,
  expiresAt: Date.now() + CONSENT_EXPIRY_DAYS * 24 * 60 * 60 * 1000,
};
